import React from 'react'
import tw from 'tailwind-styled-components'
import {IconButton} from '../buttons'

export const TwCloseIconContainer = tw.div`
  group
  absolute
  top-30
  right-20
  px-20
  py-10
`

export const TwCloseIcon = tw.div`
  w-32
  h-32
  bg-background-secondary
  group-hover:bg-background-hover
  rounded-37
  flex
  items-center
  justify-center
`

export const TwCloseText = tw.div`
  mt-4
  plain-text-regular
  text-placeholder
  text-center
  cursor-default
`

export const CloseIcon = ({onClick}: {onClick: () => void}) => {
  return (
    <TwCloseIconContainer onClick={onClick}>
      <TwCloseIcon>
        <IconButton icon="IconX" color="secondary" size="small" />
      </TwCloseIcon>
      <TwCloseText>{'esc'}</TwCloseText>
    </TwCloseIconContainer>
  )
}
